
import { Component, Mixins } from "vue-property-decorator";
import { instanceOfIWizardObjectPositionSpecifiable, instanceOfIWizardObjectSelectable, IWizardObjectOption } from "../../../../../../../domain/format";
import { default as ContentMixin } from "./ContentMixin.vue";

@Component
export default class ObjectSelectableContentMixin extends Mixins(ContentMixin) {
  get options(): IWizardObjectOption[] {
    return (this.content && instanceOfIWizardObjectSelectable(this.content) && Array.isArray(this.content.objectOptions))
      ? this.content.objectOptions
      : [];
  }

  toOptionKey(index: number): string {
    return this.content.privateId + "-" + index;
  }

  get isHorizontal(): boolean {
    return instanceOfIWizardObjectPositionSpecifiable(this.content) && this.content.isHorizontal;
  }

  get optionsClassName(): string {
    return this.isHorizontal
      ? "horizontal"
      : "";
  }
}
